import { styled } from '@mui/material/styles';

import { TextField } from '../../atoms/TextField';

export const StyledDivWrapper = styled('div')`
  width: 200px;
`;

export const StyledTextField = styled(TextField)`
  width: 250px;
`;